exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#shipping-methods[data-v-6dd2ac48]{margin-top:80px}.page-title[data-v-6dd2ac48]{margin-bottom:20px}.table th[data-v-6dd2ac48]{border-top:none}.badge[data-v-6dd2ac48]{font-size:.75em}.btn-group .btn[data-v-6dd2ac48]{margin-right:2px}.btn-group .btn[data-v-6dd2ac48]:last-child{margin-right:0}", ""]);

// exports
